import React, { Component } from 'react'
import { IFooterNavigationProps } from '../../../interfaces/Navigation.Interface'
import NavItemsList from './NavItemsList'
import Conditional from '../../common/Conditional'
import SocialNavItemsList from './SocialNavItemsList'
import { SiteLinksLayout } from '../layouts/SiteLinksLayout'
import NavItemsWithHeadingList from './NavItemsWithHeadingList'
import { INavItemWithHeadings } from '../interfaces/Navigation.Interface.Footer'
import { FooterNavLayout } from '../layouts/FooterNavLayout'

export class NavigationFooter extends Component<IFooterNavigationProps> {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <>
        <FooterNavLayout>
          <Conditional if={this.props.primary.find((i) => i.id === 1) != null}>
            <div>
              <NavItemsWithHeadingList
                navItem={
                  this.props.primary.find(
                    (i) => i.id === 1
                  ) as unknown as INavItemWithHeadings
                }
              />
            </div>
          </Conditional>

          <div>
            <Conditional
              if={this.props.primary.find((i) => i.id === 2) != null}
            >
              <NavItemsWithHeadingList
                navItem={
                  this.props.primary.find(
                    (i) => i.id === 2
                  ) as unknown as INavItemWithHeadings
                }
              />
            </Conditional>
          </div>
          <div>
            <Conditional
              if={this.props.primary.find((i) => i.id === 3) != null}
            >
              <NavItemsWithHeadingList
                navItem={
                  this.props.primary.find(
                    (i) => i.id === 3
                  ) as unknown as INavItemWithHeadings
                }
              />
            </Conditional>
          </div>
        </FooterNavLayout>
        <SiteLinksLayout>
          <NavItemsList navItems={this.props.secondary} id="sec" />
          <SocialNavItemsList navItems={this.props.social} id="soc" />
        </SiteLinksLayout>
      </>
    )
  }
}
